module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c9ziT"))).then(() => parcelRequire('iDabs'));